import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * Wraps beta-gated routes. Admins always pass; otherwise requires beta_testing_flag.
 */
export default function BetaGate({ children }) {
  const { isAuthenticated, isAdmin, betaTestingFlag } = useAuth();

  if (!isAuthenticated || (!isAdmin() && !betaTestingFlag)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
